<template>
  <div class="page_bg">
    <!-- 顶部 card-->
    <div class="bg_top_linear-gradient">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-r-s-c">
        <van-icon v-if="type === 'list'" name="arrow-left" @click="backPath" />
        <van-icon v-if="type === 'pay'" name="arrow-left" @click="$router.push('/home/index')" />
        <div class="top_name flex-c-s-s" style="margin-left:0.5rem">
          <div class="order_del_status">{{ statusList[orderInfo.orderStatus] }}</div>
          <div class="order_del_tip" style="font-size: 0.32rem;">
            <span v-if="orderInfo.orderStatus === 1 && orderInfo.payType === 1" class="flex-r-c-c">
              <van-count-down :time="time" format="HH:mm:ss 后，订单将会取消哦~" />
            </span>
            <span v-if="statusList[orderInfo.orderStatus] === '已完成'">您的订单已完成，感谢您的支持~</span>
            <span v-if="orderInfo.orderStatus === 3">账期订单已提交，正在审核中~</span>
            <span v-if="orderInfo.orderStatus === 4">账期订单已提交，等待签约中~</span>
            <span v-if="orderInfo.orderStatus === 5">您的订单正在出库，感谢您的支持~</span>
            <span v-if="orderInfo.orderStatus === 6">您的订单已经出库，感谢您的支持~</span>
            <span v-if="orderInfo.orderStatus === 7">您的订单已经发货啦，感谢您的支持~</span>
            <span v-if="orderInfo.orderStatus === 14">您的订单已支付！，等待系统确认~</span>
            <span v-if="orderInfo.orderStatus === 15">您的订单已支付！，等待系统确认~</span>
            <span v-if="statusList[orderInfo.orderStatus] === '已关闭'">订单已取消，快去重新下单吧~</span>
          </div>
        </div>
        <div class="top_icon" />
      </div>
    </div>
    <!-- 地址选择 -->
    <div class="order_address_box flex-r-sa-c" style="top: 1.68rem" @click="changeAddress('')">
      <div />
      <van-image width="0.59rem" height="0.59rem"
                 src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/mall/address.png"
      />
      <!-- <van-icon name="map-marked" class="map-marked" /> -->
      <div class="order_address_msg flex-c-s-s">
        <div class="address_msg_name">{{ orderInfo.receiptPersonName }} {{ orderInfo.receiptMobile }}
        </div>
        <div class="address_msg_addres van-multi-ellipsis--l2">
          地址：{{ orderInfo.addressFull }}
        </div>
      </div>
      <div v-if="ischangeAddress" class="order_address_change flex-r-c-c">
        <span>修改</span>
        <van-icon name="arrow" />
      </div>
      <div v-else />
      <div />
    </div>
    <!-- tab -->
    <div v-if="expressInfo.length >0" class="order_tab flex-r-s-c" style="margin-top: -1.15rem;">
      <div :class="tabIndex === 99 ? 'tab_title tab_title_actived':'tab_title'" @click="changeTab(99)">订单信息</div>
      <block v-if="expressInfo.length > 1">
        <div class="flex-r-c-c">
          <div v-for="express_index in expressInfo.length" :key="express_index"
               :class="tabIndex === (express_index*1-1) ? 'tab_title tab_title_actived':'tab_title'"
               @click="changeTab(express_index*1-1)"
          >
            包裹{{ express_index*1 }}
          </div>
        </div>
      </block>
      <div v-else :class="tabIndex === 0 ? 'tab_title tab_title_actived':'tab_title'" @click="changeTab(0)">发货清单
      </div>
    </div>
    <block v-if="tabIndex === 99">
      <!-- 商品区域 -->
      <div class="order_pro_box" :style="{marginTop: expressInfo.length === 0 ?'-1rem':'0.21rem'}">
        <div class="cart_company" style="margin-bottom:0;padding-bottom:0;margin-top: 0;">
          <!-- <div class="company_name flex-r-s-c">
          <van-icon name="shop-o" />{{ company_item.companyName }}
        </div> -->
          <div class="company_pro_list">
            <div v-for="(pro_item,pro_index) in productList" :key="pro_index" class="flex-r-s-c">
              <van-swipe-cell>
                <proCard04 :info="pro_item" />
                <!-- 优惠信息 -->
                <div v-if="pro_item.resActicityDtos" class="pro_discount_box">
                  <div class="pro_discount_items">
                    <div v-for="(discounts,discounts_index) in pro_item.resActicityDtos" :key="discounts_index"
                         class="pro_discount_item"
                    >
                      <span class="discounts_tag">{{ discounts.actionName }}：</span>
                      <span v-for="(discount,discount_index) in discounts.actions" :key="discount_index"
                            class="discounts_tag"
                      >
                        {{ discount }}
                      </span>
                    </div>
                  </div>
                </div>
              </van-swipe-cell>
            </div>
          </div>
          <van-cell-group>
            <van-field v-model="orderInfo.remark" label="备注:" placeholder="" readonly />
          </van-cell-group>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="order_check_box order_payway_box">
        <div class="check_title">订单信息</div>
        <div class="payway_types">
          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">商品总价</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem">￥{{ orderInfo.originPrice }}</span>
            </div>
          </div>
          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">运费</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem">￥{{ orderInfo.expressPrice }}</span>
              <!-- <span style="margin-right:0.21rem">￥0.00</span> -->
            </div>
          </div>
          <div v-if="activeList&&activeList.length>0" class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <van-image width="0.43rem" height="0.37rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/order/pay_minu.png"
              />
              <div class="check_item_name">商品活动</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <div v-for="(item_active,index_active) in activeList" :key="index_active" style="margin-right:0.21rem;">
                {{ item_active.name +"("+item_active.actionResult + ")" }}</div>
            </div>
          </div>

          <div v-if="orderInfo.couponPrice" class="payway_type_item flex-r-sb-c" style="margin-bottom:0.3rem">
            <div class="type_item_left check_item_left flex-r-s-c">
              <van-image width="0.43rem" height="0.37rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/order/pay_coupon.png"
              />
              <div class="check_item_name">优惠券</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;color:#ED0D0D;">-￥{{ orderInfo.couponPrice }}
              </span>
            </div>
          </div>

          <div v-if="orderInfo.discount < 100 && !orderInfo.specialPriceFlag" class="payway_type_item flex-r-sb-c"
               style="margin-bottom:0.3rem"
          >
            <div class="type_item_left check_item_left flex-r-s-c">
              <van-image width="0.43rem" height="0.37rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/vip_sub_icon.png"
              />
              <div class="check_item_name">{{ orderInfo.wholesaleVipLevelName }}享{{ orderInfo.discount }}折</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;color:#ED0D0D;font-size: 0.32rem;">-￥{{ orderInfo.vipDiscountPrice }}
              </span>
            </div>
          </div>
          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">实付款</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;color:#ED0D0D;font-size:0.48rem"><span
                style="color:#ED0D0D;font-size:0.37rem"
              >￥</span>{{ orderInfo.orderPrice }}</span>
            </div>
          </div>

          <van-divider />

          <!-- <div class="payway_type_item flex-r-sb-c">
          <div class="type_item_left check_item_left  flex-r-s-c">
            <div class="check_item_name">支付方式</div>
          </div>
          <div class="type_item_right  flex-r-s-c">
            <van-icon name="wechat-pay" color="rgb(9, 187, 7)" size="0.51rem" />
            <span style="margin-right:0.21rem;font-weight:400">在线支付</span>
          </div>
        </div> -->

          <div v-if="orderInfo.payType === 3" class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">还款日期</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;font-weight:400">{{ orderInfo.installmentBackDate }}</span>
            </div>
          </div>

          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">订单编号</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;font-weight:400">{{ orderInfo.orderNo }}</span>
            </div>
          </div>

          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">下单时间</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;font-weight:400">{{ orderInfo.createTime }}</span>
            </div>
          </div>

          <div class="payway_type_item flex-r-sb-c">
            <div class="type_item_left check_item_left  flex-r-s-c">
              <div class="check_item_name">需要货单</div>
            </div>
            <div class="type_item_right  flex-r-s-c">
              <span style="margin-right:0.21rem;font-weight:400">{{ orderInfo.followPdfPrint === 0 ? '否':'是' }}</span>
            </div>
          </div>
        </div>
      </div>
    </block>
    <block v-else>
      <div class="express_box">
        <div :class="expressTab === 'left'? 'express_box_title bg_left':'express_box_title bg_right'">
          <div :class="expressTab === 'left'? 'title title_actived':'title'" @click="changeExpressTab('left')">物流信息
          </div>
          <div :class="expressTab === 'right'? 'title title_actived':'title'" @click="changeExpressTab('right')">发货明细
          </div>
        </div>
      </div>
      <!-- 物流信息 -->
      <div v-if="expressTab === 'left'" class="express_box_info">
        <div class="express_name"> {{ expressInfo[tabIndex].expressName }}：{{ expressInfo[tabIndex].expressNo }} </div>
        <van-divider />
        <van-steps direction="vertical" :active="0" active-color="#0767AB" inactive-icon="checked">
          <van-step v-for="(step_item,step_index) in expressInfo[tabIndex].expressItemList" :key="step_index"
                    class="express_step"
          >
            <!-- <div class="step_status">派送中</div> -->
            <div class="step_msg">{{ step_item.remark }}</div>
            <div class="step_time">{{ step_item.acceptTime }}</div>
          </van-step>
        </van-steps>
        <br>
      </div>
      <!-- 商品区域 -->
      <div v-if="expressTab === 'right'" class="order_express_pro_box">
        <div class="cart_company" style="margin-bottom:0;padding-bottom:0;padding-top: 0;margin-top: 0;">
          <div class="company_pro_list">
            <div v-for="(pro_item,pro_index) in expressInfo[tabIndex].productResponseList" :key="pro_index"
                 class="flex-r-s-c"
            >
              <van-swipe-cell>
                <proCard04 :info="pro_item" :discount="true" />
              </van-swipe-cell>
            </div>
          </div>
        </div>
      </div>
    </block>
    <!-- 底部bar -->
    <orderDel ref="orderSub" :info="orderInfo" :bank-info="bankInfo" style="z-index: 999;" @action="action" />
  </div>
</template>

<script>
import './index.scss'
import './../cart/index.scss'
import orderDel from '@/components/bar/order_del'
import {
  mallOrder_buyer_detail, mallOrder_buyer_detail_product, bankInfo,
  mallOrder_updateReceipt, bankTransferFinish, copyOrder, apiWholesaleOrder_offOrder,
  mallOrder_orderExpressList
} from '@/api/order'
import proCard04 from '@/components/pro_card_04'
import { orderPayStatus } from '@/utils/constants'
export default {
  name: 'OrderDetail',
  components: { proCard04, orderDel },
  data() {
    return {
      ischangeAddress: false,
      orderId: '',
      type: 'list',
      orderInfo: {},
      productList: [],
      activeList: [],
      time: null,
      statusList: orderPayStatus.statusList,
      bankInfo: {},

      tabIndex: 99,
      expressInfo: [],
      expressTab: 'left'
    }
  },
  created() {
    this.orderId = this.$route.query.id
    this.type = this.$route.query.type || 'list'
    this.getDetail()
    this.getBankInfo()
  },
  methods: {
    backPath() { window.history.back() },
    getDetail() {
      // 获取倒计时
      var nowData = Date.now()
      // 订单信息
      mallOrder_buyer_detail({ orderId: this.orderId }).then(res => {
        this.orderInfo = res.data
        this.time = res.data.expireTimestamp - nowData
        if (JSON.parse(sessionStorage.getItem('address')) && (this.orderInfo.orderStatus === 1)) {
          this.orderInfo.receiptPersonName = JSON.parse(sessionStorage.getItem('address')).name
          this.orderInfo.receiptMobile = JSON.parse(sessionStorage.getItem('address')).tel
          this.orderInfo.addressFull = JSON.parse(sessionStorage.getItem('address')).address
          this.orderInfo.companyAddress = ''
          mallOrder_updateReceipt({ orderId: this.orderId, receiptAddressId: JSON.parse(sessionStorage.getItem('address')).id }).then(res => {
            sessionStorage.removeItem('address')
          })
        }
        this.getExpressInfo()
      })
      // 商品信息2
      mallOrder_buyer_detail_product({ orderId: this.orderId }).then(res => {
        this.productList = res.data.list
      })
    },
    // 获取物流信息
    getExpressInfo() {
      mallOrder_orderExpressList({ page: 1, limit: 999, orderId: this.orderId }).then(res => {
        this.expressInfo = res.data.list
      })
    },
    // 切换tab
    changeTab(index) { this.tabIndex = index },
    changeExpressTab(value) { this.expressTab = value },
    // 获取对公信息
    getBankInfo() {
      bankInfo({ orderId: this.orderId }).then(res => {
        this.bankInfo = res.data
        this.isBillShow = (res.data.orderPrice * 1) > 50000
      })
    },
    // 底部行为
    action(e) {
      console.log(e)
      // if (e === 'pay') { this.$router.push('/order/payResult?orderId=' + this.orderId + '&status=4&onlinePayType=' + this.orderInfo.onlinePayType) }
      if (e === 'pay') {
        const status = parseInt(this.orderInfo.onlinePayType) === 2 ? '6' : '4'
        this.$router.push('/order/payResult?orderId=' + this.orderId + '&status=' + status + '&onlinePayType=' + this.orderInfo.onlinePayType)
      }
      if (e === 'address') { this.ischangeAddress = !this.ischangeAddress }
      if (e === 'new') {
        copyOrder({ orderId: this.orderId }).then(res => { this.$router.replace('/cart/cart') })
      }
      if (e === 'return') { this.$router.push('/order/orderReturn?orderId=' + this.orderId) }
      if (e === 'returnInfo') { this.$router.push('/order/returnStatus?orderId=' + this.orderId) }
      if (e === 'express') { this.$router.push('/order/expressInfo?orderId=' + this.orderId) }
      if (e === 'bank') {
        bankTransferFinish({ orderId: this.orderId }).then(res => {
          this.$toast('已提交确认！')
          this.$router.replace('/order/orderDetail?id=' + this.orderId + '&type=pay')
        })
      }
      if (e === 'cancer') {
        this.$dialog.confirm({
          title: '注意',
          message: '是否取消当前订单'
        })
          .then(() => {
            apiWholesaleOrder_offOrder({ orderId: this.orderId }).then(res => {
              this.$toast('已提交确认！')
              this.$router.replace('/order/orderDetail?id=' + this.orderId + '&type=pay')
            })
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 修改地址
    changeAddress(addressId) {
      if (this.ischangeAddress) {
        this.$router.push('/user/addressList?aId=' + addressId)
      }
    }
  }
}
</script>

<style>
.van-count-down {
  color: #fff;
}
</style>
